'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadI18n = undefined;

var _load = require('I18n/load');

var _load2 = _interopRequireDefault(_load);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* This returns a native Promise, not a Q promise */
var loadI18n = exports.loadI18n = function loadI18n(config) {
  return (0, _load2.default)(config);
};


//////////////////
// WEBPACK FOOTER
// ./js/utils/loadI18n.js
// module id = 459
// module chunks = 2 3